<ng2-smart-table [settings]="settings" [source]="source"></ng2-smart-table>


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/site/site-pages-table/site-pages-table.component.html